<ng-container *ngIf="isStockOrderpad">
  <small class="d-block mb-2">{{ 'last.updated' | translate }} {{ lastUpdatedDateDisplay | hkDate: null: dateFormat }}</small>
  <div class="orderpad-technical-analysis" id="orderpad_ta_chart_container"></div>
</ng-container>

<ng-container *ngIf="!isStockOrderpad">
  <div class="technical-analysis" id="stock_ta_chart_container"></div>
</ng-container>
